<script>
import { isEmpty } from 'lodash'
import api from '@/helpers/api'

export default {
  name: 'product-category-selector',
  components: {},
  props: {
    value: { type: String }
  },
  data: () => ({
    data: [],
    category: {},
    showModal: false,
    crumbs: [],
    level: 0
  }),
  watch: {
    value: {
      handler: 'init',
      immediate: true
    }
  },
  async mounted () {
    this.init()
  },
  methods: {
    isEmpty,
    async loadData (parentCategory = null) {
      let filters = []
      if (!isEmpty(parentCategory)) {
        this.category = { ...parentCategory }
        filters = [{ parent_category_id: { _eq: parentCategory.id } }]
      } else {
        filters = [{ parent_category_id: { _is_null: true } }]
        this.category = {}
      }
      let { items } = await api.productCategories.fetchPage({
        page: 1,
        pageSize: -1,
        filters
      })

      this.data = [...items]
    },
    async init () {
      if (this.value) {
        let item = await api.productCategories.fetch({
          id: this.value
        })
        this.loadData(item)
      } else {
        this.loadData({})
      }
    },
    async openModal () {
      this.loadData(this.category)
      this.showModal = true
    },
    onCancel () {
      this.showModal = false
    },
    onSave () {
      this.showModal = false
      this.$emit('input', this.category.id)
    },
    onLevelUp () {
      this.level = this.level - 1
      this.crumbs.length = this.level
      this.loadData(this.category.parent_category)
    },
    onLevelDown (category) {
      this.level = this.level + 1
      this.crumbs.push(category)
      this.loadData(category)
    },
    onGoToLevel (level, category) {
      this.level = level
      this.crumbs.length = level
      this.loadData(category)
    },
    onClear () {
      this.$emit('input', null)
    }
  },
  computed: {
    selectedCategoryName () {
      return this.category.name || '- Click to Select a Category -'
    },
    saveBtnLabel () {
      return !isEmpty(this.category)
        ? `Select ${this.category.name}`
        : 'Nothing Selected'
    },
    breadCrumbs () {
      if (isEmpty(this.category)) return []
      return [
        {
          text: this.category.name,
          active: true
        }
      ]
    }
  }
}
</script>
<template>
  <div>
    <b-input-group>
      <b-form-input
        v-model="selectedCategoryName"
        v-on:click="openModal"
        readonly
        v-bind="$attrs"
      />
      <b-input-group-append is-text v-if="!isEmpty(category)">
        <i class="fa fa-times pointer" v-on:click="onClear"></i>
      </b-input-group-append>
    </b-input-group>
    <b-modal v-model="showModal" size="lg" centered hide-header>
      <b-breadcrumb class="bg-transparent">
        <b-breadcrumb-item v-on:click="onGoToLevel(0, null)">
          <i class="bx bxs-home mr-2"></i>TOP
        </b-breadcrumb-item>
        <template v-for="(c, idx) in crumbs">
          <b-breadcrumb-item
            :key="c.id"
            v-on:click="onGoToLevel(idx + 1, c)"
            v-if="idx + 1 < crumbs.length"
            >{{ c.name }}</b-breadcrumb-item
          >
          <b-breadcrumb-item :key="c.id" active v-else>{{
            c.name
          }}</b-breadcrumb-item>
        </template>
      </b-breadcrumb>
      <div class="d-flex justify-content-start flex-wrap" v-if="!isEmpty(data)">
        <b-btn
          v-for="cat in data"
          :key="cat.id"
          v-on:click="onLevelDown(cat)"
          variant="outline-primary"
          size="lg"
          :squared="true"
          class="m-1 p-4"
          :style="{ minWidth: '140px' }"
          >{{ cat.name }}</b-btn
        >
      </div>
      <div v-else class="text-center p-4">No Sub Categories</div>
      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end" style="width:100%">
          <b-btn
            variant="outline-secondary"
            @click="onLevelUp"
            class="mr-2"
            :disabled="isEmpty(category)"
            v-if="false"
          >
            <i class="fas fa-arrow-circle-up mr-2"></i>Up
          </b-btn>
          <div>
            <b-btn variant="outline-secondary" @click="onCancel" class="mr-2"
              >Cancel</b-btn
            >
            <b-btn
              variant="primary"
              class="btn-label"
              @click="onSave"
              :disabled="isEmpty(category)"
            >
              <i class="fas fa-check label-icon"></i>
              {{ saveBtnLabel }}
            </b-btn>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
